/* eslint-disable sort-keys-fix/sort-keys-fix */
export const ParticipantStatus = {
    ADDED: "added",
    INVITED: "invited",
    TERMS_AND_CONDITIONS_ACCEPTED: "termsAndConditionsAccepted",
    INVITATION_ACCEPTED: "invitationAccepted",
    REDIRECTED_TO_ONLINE: "redirectedToOnline",
    IN_PROGRESS: "inProgress",
    PHASE_ONE_FINISHED: "phaseOneFinished",
    HNA_FINISHED: "hnaFinished",
    PERSONA_FIT_FINISHED: "personafitFinished",
    COMPLETED: "completed",
    GRANTED: "granted",
    DENIED: "denied",
    WAITING_FOR_DECISION: "waitingForDecision",
    CLOSED: "closed",
    REJECTED: "rejected",
};
